<div class="other-assumptions-compare">
  <klt-section
    title="Other assumptions"
    type="button"
    buttonText="COMPARE"
    (buttonClick)="handleClick()"
  >
  </klt-section>
</div>
